import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { IContactDetails, ICountry, ILanguage } from '../core/models/contact-details.model';
import { NgxTurnstileModule, NgxTurnstileFormsModule } from "ngx-turnstile";
import { environment } from '../../environments/environment';
import { TurnstileService } from '../core/services/turnstile.service';
import { ContactUsService } from '../core/services/contact-us.service';
import { LanguageService } from '../core/services/language.service';
import countriesData from '../core/data/countries.json';


@Component({
  selector: 'app-contact-details',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgxTurnstileModule],
  templateUrl: './contact-details.component.html',
  styleUrl: './contact-details.component.css'
})
export class ContactDetailsComponent implements OnInit {
  @Output()
  formReady = new EventEmitter<FormGroup>();

  @Input()
  parentForm: FormGroup;

  @Input()
  showValidationError = false;

  @Input()
  showSubmissionError = false;

  siteKey = environment.turnstileSiteKey;

  loaderIcon: boolean = false;

  constructor(private fb: FormBuilder, private turnstileService: TurnstileService, private contactUsService: ContactUsService, private languageService: LanguageService) {}

  form: FormGroup;

  get labels() { return this.contactUsService.contactDetailsLabels; }
  get commonLabels() { return this.contactUsService.commonLabels; }
  get placeholders() { return this.contactUsService.placeholderTextLabels; }
  get messages() { return this.contactUsService.messageLabels; }

  get listLabels() { return this.contactUsService.listLabels; }



  ngOnInit(): void {

    const lang = this.languageService.getLanguageFromUrl();

    const priorityNames = ['United States', 'United Kingdom', 'Mexico', 'France', 'Spain'];

    const priorityData = priorityNames.map(name => (countriesData as any[]).find(c => c.name === name)!);
    const restData = (countriesData as any[]).filter(c => !priorityNames.includes(c.name));

    this.topCountries = lang === 'fr-fr'
      ? priorityData.map(c => ({ name: c.nameFr || c.name }))
      : priorityData.map(c => ({ name: c.name }));

    this.countries = lang === 'fr-fr'
      ? restData.map(c => ({ name: c.nameFr || c.name }))
      : restData.map(c => ({ name: c.name }));

    this.contactUsService.getDictionary(lang).subscribe(() => {
      const languages = this.listLabels.languages;
      if (languages) {
        this.filteredLanguages = Object.keys(languages).map(key => ({
          code: key,
          name: (languages as any)[key]
        }));

        if (!this.filteredLanguages.some(language => language.code === 'other')) {
          this.filteredLanguages = [
            ...this.filteredLanguages,
            { code: 'other', name: this.placeholders.otherLang }
          ];
        }
      }
    });

    this.form = this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      company: [''],
      email: ['', [Validators.required, Validators.email]],
      confirmEmail: ['', [Validators.required, Validators.email]],
      country: ['', [Validators.required]],
      preferredLanguage: ['', [Validators.required]],
      agreeTerms: [false, [Validators.requiredTrue]],
      turnstile: ['', [Validators.required]]
    }, { validators: this.emailMatchValidator });

    this.formReady.emit(this.form);
  }

  onCaptchaResolved(token: string): void {
    this.form.get('turnstile')?.setValue(token);
    this.turnstileService.setToken(token);
  }

  /**
   * Custom validator to check if email and confirmEmail match
   * @param control - The form group control
   * @returns ValidationErrors or null
   */
  emailMatchValidator(control: AbstractControl): ValidationErrors | null {
    const email = control.get('email')?.value;
    const confirmEmail = control.get('confirmEmail')?.value;

    if (!email || !confirmEmail) {
      return null;
    }

    return email === confirmEmail ? null : { emailMismatch: true };
  }

  /**
   * Checks if a specific field is invalid and has been touched
   * @param fieldName - The name of the form field
   * @returns True if the field is invalid and touched
   */
  isFieldInvalid(fieldName: string): boolean {
    const field = this.form.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }

  /**
   * Checks if the form has the emailMismatch error
   * @returns True if emails don't match
   */
  hasEmailMismatch(): boolean {
    return !!(
      this.form.hasError('emailMismatch') &&
      this.form.get('confirmEmail')?.touched
    );
  }


    topCountries: ICountry[] = [];
    countries: ICountry[] = [];

  filteredLanguages: { code: string; name: string }[] = [];




}
